<template>
  <div>
    <PhotoGalleryComponent
        :photos="speciesPhotoInNature"
        :base-compressed-photo-url=baseCompressedPhotoUrl
        :base-origin-photo-url=baseOriginPhotoUrl
        :deletePhoto="deletePhoto"
        :can-be-updated="true"
        :isAdmin="isAdmin"
        :photo-type="`photoOfSpeciesInNature`"
        @open-update-component="(index) => openModal(index)"
    />

    <v-dialog
        v-if="isShowUpdateComponent"
        v-model='isShowUpdateComponent'
        fullscreen
        :scrim='false'
        transition='dialog-bottom-transition'
        width="100vw"
    >
      <v-card tile>
        <v-toolbar
            tile
            dark
            color='primary'
        >
          <v-btn
              icon
              dark
              @click='dropModal'
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Редактирование фото вида в природе</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-form
            id="exhibitPhotoUpdateForm"
            v-model="valid"
            style="width: 100vw"
            lazy-validation
            ref="exhibitPhotoUpdateForm"
        >
          <div>
            <v-row class="pa-2">
              <v-col cols="12" sm="4">
                <v-card tile class="pa-4">
                  <v-text-field
                      readonly
                      disabled
                      v-model="species"
                      autocomplete="off"
                      label="Название вида"
                  />
                  <v-textarea
                      v-model="photoToUpdate.newDescription"
                      autocomplete="off"
                      label="Описание к фотографии"
                      :rules="nameRules"
                  />
                </v-card>

                <v-card tile class="mt-1" elevation="0">
                  <v-card-title>Заменить фото</v-card-title>
                  <UploadScans :rules="[maxOneFile]" :label-text="'Прикрепите фото нажав сюда'" @pass="setUpdatedImage"/>
                </v-card>
              </v-col>

              <v-col cols="12" sm="4">
                <v-card tile class="pa-4">
                  <v-card-title class="pt-0">Текущее фото</v-card-title>
                  <v-card-text>
                    <v-img
                        width="100%"
                        :src="photoToUpdate.previewImageSrc"
                    >
                    </v-img>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="pl-2">
              <v-col class="pt-0">
                <v-btn tile outlined text @click="updatePhotoOfSpecies">
                  Сохранить
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {fetchSpeciesPhoto, deleteSpeciesPhoto, updateSpeciesPhotoDescription, updateSpeciesPhotoImage} from "@/services/speciesAPI";
import {photoOfSpeciesOriginPath, photoOfSpeciesCompressedPath} from "@/helpers/siteURL";
import PhotoGalleryComponent from "@/components/ExhibitPageComponents/PhotoGalleryComponent.vue";
import UploadScans from "@/components/ExhibitCreationPageComponents/UploadScans.vue";
import CreationForm from "@/components/NewCreationPageComponents/CreationForm.vue";
import ToastService from "@/services/toastService";

export default {
  name: "ExhibitPhotos",
  components: {
    UploadScans,
    PhotoGalleryComponent,
    CreationForm
  },
  data() {
    return {
      isShowUpdateComponent:false,
      valid: true,
      arePhotos: true,
      speciesPhotoInNature: [],
      baseCompressedPhotoUrl: photoOfSpeciesCompressedPath,
      baseOriginPhotoUrl: photoOfSpeciesOriginPath,
      photoToUpdate: {
        indexInSpecies: 0,
        species: '',
        globalIndex: 0,
        newDescription: '',
        newImage: null,
        previewImageSrc: null,
      },
      maxOneFile: (fileList) => {
        if (!fileList || fileList.length === 0) {
          return true;
        }
        return fileList.length <= 1 || 'Можно загрузить только одно изображение';
      },
      nameRules: [
        v => !!v || 'Поле не может быть пустым',
      ],
    }
  },
  props: {
    species: {
      type: String,
      required: true,
    },
    taxonomy: {
      type: String,
      required: true
    },
    labelName: {
      type: String,
      required: true
    }
  },

  methods: {
    async deletePhoto (globalIndex) {
      const speciesAndIndex = this.getSpeciesAndIndexByGlobalIndex(globalIndex)
      try {
        await deleteSpeciesPhoto(speciesAndIndex.species, speciesAndIndex.indexInSpecies)
        this.speciesPhotoInNature = this.speciesPhotoInNature.filter((item) => this.speciesPhotoInNature.indexOf(item) !== globalIndex)
      } catch (e) {
        console.log(e);
      }
    },
    async updatePhotoOfSpecies() {
      try {
        if (this.photoToUpdate.newDescription !== this.speciesPhotoInNature[this.photoToUpdate.globalIndex].description) {
          const descriptionData = await updateSpeciesPhotoDescription(this.photoToUpdate.species, this.photoToUpdate.indexInSpecies, this.photoToUpdate.newDescription);
          ToastService.toastSuccess(descriptionData.result);
          this.photoToUpdate.newDescription = '';
        }

        if (this.photoToUpdate.newImage !== null) {
          const imageData = await updateSpeciesPhotoImage(this.species, this.photoToUpdate.indexInSpecies, this.photoToUpdate.newImage[0]);
          ToastService.toastSuccess(imageData.result);
          this.photoToUpdate.newImage = null;
        }

        await this.refresh();
      } catch (error) {
        ToastService.error(error.response.message);
      } finally {
        this.dropModal();
      }
    },
    openModal(globalIndex) {
      const { species, indexInSpecies } = this.getSpeciesAndIndexByGlobalIndex(globalIndex);
      const newDescription = this.speciesPhotoInNature[globalIndex].description
      const previewImageSrc = this.baseCompressedPhotoUrl + '/' + this.speciesPhotoInNature[indexInSpecies].compressedPhotoPath
      Object.assign(this.photoToUpdate, { indexInSpecies, species, globalIndex, newDescription, previewImageSrc });
      this.isShowUpdateComponent = true
    },
    dropModal() {
      this.isShowUpdateComponent = false
    },
    async setUpdatedImage(image) {
      this.photoToUpdate.newImage = image;

      const reader = new FileReader();
      reader.onload = async () => { this.photoToUpdate.previewImageSrc = reader.result;};
      reader.onerror = error => console.error("Error reading file:", error);
      reader.readAsDataURL(this.photoToUpdate.newImage[0]);
    },
    async refresh() {
      await fetchSpeciesPhoto(this.$props.species,this.$props.taxonomy,this.$props.labelName)
          .then(data => this.speciesPhotoInNature = this.transformResponse(data))
          .catch((e) => {this.arePhotos = false})
      if (this.speciesPhotoInNature.length === 0) this.arePhotos = false
    },
    transformResponse(responseData) {
      return  responseData.flatMap(item =>
          item.photos.map(photo => ({
            species: item.species,
            fullPhotoPath: photo.originPhotoUrl,
            compressedPhotoPath: photo.compressedPhotoUrl,
            description: photo.description,
            createdAt: photo.createdAt,
          }))
      );
    },
    getSpeciesAndIndexByGlobalIndex(globalIndex) {
      if (globalIndex < 0 || globalIndex >= this.speciesPhotoInNature.length) {
        return { species: null, indexInSpecies: -1 };
      }
      const targetSpecies = this.speciesPhotoInNature[globalIndex].species
      const startIndex = this.speciesPhotoInNature.findIndex((photo, index) => photo.species === targetSpecies && index <= globalIndex);
      return { species: targetSpecies, indexInSpecies: globalIndex - startIndex };
    }
  },

  computed: {
    isAdmin() {
      return this.$store.getters.getIsViewAdminPanel;
    }
  },

  async created() {
    await this.refresh()
  },
}
</script>

<style scoped>

</style>